import React from "react";
import { useEffect, useState, useRef } from "react";
import { viewdisbursementlist,paydisburesment } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { message } from 'antd';
import {UploadOutlined} from "@ant-design/icons"
import CustomModal from "../../../input-components/Modal";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import "../WithDrawals/withdrawal.css"
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';

const Disbursement = () => {
    const [disbursementLists, setDisbursementLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(1);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowIds, setRowIds] = useState("");
    const [openDisburseModle,setOpenDisburseModle] = useState(false)
    const ToastRef = useRef();
  const navigate = useNavigate();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getSupportList(1, 10);
    }, [userId, searchText, purpose]);



    const getSupportList = (currentPage, totalRows) => {
        const baseUrl = viewdisbursementlist;
        let data = {
            AgencyId: agencyID,
            TabId: purpose,
        };

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let disburseData = response.list;
                    if(purpose === 3){
                    let disbursementList = disburseData
                    .map((dis) => ({
                        reference: dis.reference,
                        folio: dis.folio,
                        lastPayment: dis.lastPayment,
                        payBy: dis.payBy,
                        billPending: dis.billDue,
                        invoicePending: dis.invoicePending,
                        balance: dis.balance,
                        id: dis.folio,
                    }));
                setDisbursementLists(disbursementList);
                    }else {
                        let disbursementList = disburseData
                        .map((dis) => ({
                            reference: dis.reference,
                            propertyAddress: dis.propertyAddress,
                            folio: dis.folio,
                            lastPayment: format(new Date(dis.lastPayment), 'dd/MM/yyyy'),
                            dueDate: format(new Date(dis.dueDate), 'dd/MM/yyyy'),
                            payBy: dis.payBy,
                            withholdAmount: dis.withholdAmount,
                            billDue: dis.billDue,
                            fees: dis.fees,
                            payout: dis.payout,
                            id: dis.folio,
                        }));
                    setDisbursementLists(disbursementList);
                    }
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getSupportList(pageNumber, totalRows);
    };

    const tabColumns = {
        Status: {
            colorMap: {
                "Resolved": "#00A5A2",
                "Created": "#E5A000",
            },
            defaultColor: 'blue'
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };


    const actions = [
        { icon: "/assets/images/dots.svg",key:"View", onClick: (e, data) => handleView(e, data) },
        // { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
    ]

   
    const onSelectedRowKeysChange = (selectedKeys, selectedRows) => {
        setRowIds(selectedKeys); // Store it as JSON string for easier display/use
    };
    
        

    const handleStatClick = (selectedPurpose) => {
        console.log(selectedPurpose,'selectedPurpose')
          setPurpose(selectedPurpose);
      };

      const handleDisburse = () => {
        setOpenDisburseModle(true)
      }

      const closeDisburse = () => {
        setOpenDisburseModle(false)
        setRowIds([])
      }
      const submitDisburse = () => {
        const baseUrl = paydisburesment;
        let data = {
            AgencyId: agencyID,
            Folios: rowIds
        };

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    setOpenDisburseModle(false);
                    setRowIds([])
                    getSupportList();

                } else {
                    ToastRef.current.notify(["error", response.message]);

                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };
    
    const handleNavOpen = () => {
        navigate("/agency/accounts/disbursements/WithDrawals")
    }

    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Disbursement"} goback={false} extraData={true} extraContent={
                            <div className="property-details-buttons">
                              <button   className="withdraw-btn"  onClick={handleNavOpen}>
                                    Withdrawals
                                </button>
                                <button className="main-subnav-btn" onClick={handleDisburse}>
                                    <UploadOutlined className="mr-1" /> Disburse
                                </button>
                              
                            </div>
                              } />
                    <div className="material-work-desk-new bg-white m-3">
                    <ToastAlert ref={ToastRef} />
                        <div className="">
                           
                            <span
                                className={`stat-items ${purpose === 1 ? 'active' : ''}`}
                                onClick={() => handleStatClick(1)}
                            >
                                Due Owner
                            </span>
                            <span
                                className={`stat-items ${purpose === 2 ? 'active' : ''}`}
                                onClick={() => handleStatClick(2)}
                            >
                                All Owner
                            </span>
                            <span
                                className={`stat-items ${purpose === 3 ? 'active' : ''}`}
                                onClick={() => handleStatClick(3)}
                            >
                                All Supplier
                            </span>

                           
                        </div>
                        <AntdTableExample
                            showCheckbox
                            label="List Disbursement"
                            dataSource={disbursementLists}
                            globalSearch
                            hideCol={"id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            tagColumns={tabColumns}
                            onSearchValueChange={handleSearchValueChange}
                            actions={actions}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            initialSelectedRowKeys={rowIds}
                            highlightColumns={{
                                reference: '#2980b9',
                                folio: '#2980b9',
                            }}
                        />
                    </div>
                    <CustomModal width={650} closable={closeDisburse} visible={openDisburseModle} onCancel={closeDisburse}
                        modalData={
                            <div>
                                <div style={{ padding: "20px" }}>
                                    <h5 style={{ color: "#348fb2", fontWeight: 600 }}>
                                        Are you sure you want to disburse the  {rowIds.length > 0 ? rowIds.length : 0}  selected folios now?
                                    </h5>
                                    <p style={{ marginBottom: "15px", fontSize: "14px", color: "#333" }}>
                                        New entries will be created in the withdrawals list.
                                    </p>
                                    <div style={{
                                        background: "#f4f6f8",
                                        padding: "12px 15px",
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "14px"
                                    }}>
                                        <span style={{ marginRight: "10px", color: "#3c8dbc" }}>💡</span>
                                        You will need to process the withdrawals to mark those funds as having left your trust account.
                                    </div>


                                </div>


                            </div>
                        }
                        footer={<div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
                            <button onClick={closeDisburse} style={{ marginRight: "10px" }} className="btn btn-light">
                                Cancel
                            </button>
                            <button style={{background:"#348fb2", color:"white"}} onClick={() => {submitDisburse()}} className="btn">
                                OK
                            </button>
                        </div>} title={null}

                    />
                </div>
            </div>
        </div>
    );
};

export default Disbursement;
